module.exports = __webpack_public_path__ + "img/imagen1mayo_web.d1daf745.jpg";